import MenuLinks from './MenuLinks';

export default MenuLinks;
